import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Form, Modal, Spinner } from "react-bootstrap";
import ReactPlayer from "react-player";
import { Fetcher } from "../../../../Helpers/fetcher";

const TranscribeModal = ({ show, onClose, transcriptUrl }) => {
    const [gender, setGender] = useState("");
    const [loading, setLoading] = useState(false);
    const [transcriptData, setTranscriptData] = useState(null);
    const [showListenModal, setShowListenModal] = useState(false);

    const getTranscribe = async () => {
        if (!transcriptUrl || !gender) return;

        setLoading(true);

        const payload = {
            audioUrl: transcriptUrl,
            gender,
        };

        try {
            const response = await Fetcher.post("https://tts.ivrsms.com/voicetohindi", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (response.status === "success") {
                setTranscriptData(response);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        getTranscribe();
    };

const handleClose=()=>{
    setShowListenModal(false)
    setTranscriptData(null)
    setGender("")
    setLoading(false)
    onClose()
}

    return (
        <Modal size="md" show={show} onHide={() => !loading && handleClose()}>
            <Modal.Header closeButton={!loading}>
                <Modal.Title>Transcribe Voice File</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ position: "relative", minHeight: "200px" }}>
                {loading ? (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.7)",
                            zIndex: 10,
                        }}
                    >
                        <div className="text-center">
                            <Spinner animation="border" />
                            <div className="mt-2">Processing...</div>
                        </div>
                    </div>
                ) : !transcriptData ? (
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>Select Gender</Form.Label>
                            <Form.Select
                                required
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                                disabled={loading}
                            >
                                <option value="">Select Gender</option>
                                <option value="MALE">Male</option>
                                <option value="FEMALE">Female</option>
                            </Form.Select>
                        </Form.Group>

                        <div>
                            <Button type="submit" disabled={loading || !gender}>
                                Submit
                            </Button>
                        </div>
                    </Form>
                ) : (
                    <Card className="shadow border-0">
                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <Card.Title className="mb-0">Transcript Result</Card.Title>
                                <Badge bg="success">{transcriptData.detectedLanguage}</Badge>
                            </div>

                            <hr />

                            <div className="mb-3">
                                <h6 className="text-muted">Original Language</h6>
                                <div className="bg-light p-3 rounded border small">
                                    {transcriptData.transcript}
                                </div>
                            </div>

                            <div className="mb-3">
                                <h6 className="text-muted">Hindi Translation</h6>
                                <div className="bg-light p-3 rounded border small">
                                    {transcriptData.hindiText}
                                </div>
                            </div>

                            <hr />

                            {showListenModal && <div className="mb-3">
                                <h6 className="text-muted">Listen Transcribe</h6>
                                <div className="bg-light p-3 rounded border small">
                                    <ReactPlayer url={transcriptData?.downloadUrl} controls width='90%' height='80px' />
                                </div>
                            </div>}

                            <div className="d-flex justify-content-between">
                                <Button
                                    variant="success"
                                    onClick={() => window.open(transcriptData.downloadUrl, "_blank")}
                                >
                                    Download Audio
                                </Button>
                                {transcriptData.downloadUrl && <Button
                                    variant="primary"
                                    onClick={() => setShowListenModal(true)}
                                >
                                    Listen Audio
                                </Button>}
                            </div>
                        </Card.Body>
                    </Card>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default TranscribeModal;